<h2 mat-dialog-title>CSV Preview — Crusher Data Import</h2>

<mat-dialog-content class="preview-content">
  <div class="preview-summary">
    <div class="summary-row">
      <span class="summary-label">Total columns in CSV</span>
      <span class="summary-value">{{ data.csvColumns.length }}</span>
    </div>
    <div class="summary-row">
      <span class="summary-label">Existing columns</span>
      <span class="summary-value text-success">{{ data.existingColumns.length }}</span>
    </div>
    <div class="summary-row">
      <span class="summary-label">New columns detected</span>
      <span class="summary-value text-warning">{{ data.newColumns.length }}</span>
    </div>
    <div class="summary-row">
      <span class="summary-label">Data rows</span>
      <span class="summary-value">{{ data.totalDataRows }}</span>
    </div>
  </div>

  @if (data.newColumns.length > 0) {
    <div class="alert alert-warning mt-3 mb-2">
      <strong>{{ data.newColumns.length }} new {{ data.newColumns.length === 1 ? 'column has' : 'columns have' }} been detected</strong> in the CSV file and will be added to the database.
    </div>

    <table class="table table-sm new-columns-table">
      <thead>
        <tr>
          <th>Column name</th>
          <th>Detected type</th>
        </tr>
      </thead>
      <tbody>
        @for (col of data.newColumns; track col.columnName) {
          <tr>
            <td>
              <span class="new-column-badge">NEW</span>
              <code>{{ col.columnName }}</code>
            </td>
            <td>
              <span class="type-badge">{{ col.detectedType }}</span>
              @if (col.isFallbackType) {
                <span class="text-muted ms-1 small">(fallback — could not determine precise type)</span>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  }

  @if (data.newDataRows === 0 && data.newColumns.length === 0) {
    <div class="alert alert-info mt-3 mb-0">
      <i class="fas fa-check-circle me-1"></i>
      <strong>The crusher data is up to date.</strong> No new rows to insert.
    </div>
  }

  @if (data.previewRows && data.previewRows.length > 0) {
    <div class="rows-header mt-3 mb-0">
      <span class="rows-count">{{ data.newDataRows }}</span>
      <span class="rows-label">rows to insert</span>
      @if (dateRange(); as dr) {
        <span class="rows-period">{{ dr.from }} — {{ dr.to }}</span>
      }
      @if (data.previewRows.length < data.newDataRows) {
        <span class="rows-preview">preview {{ data.previewRows.length }} of {{ data.newDataRows }}</span>
      }
    </div>
    <div class="preview-data-table-wrapper">
      <table class="table table-sm table-bordered preview-data-table">
        <thead>
          <tr>
            @for (col of data.csvColumns; track col) {
              <th>{{ col }}</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (row of data.previewRows; track $index) {
            <tr>
              @for (col of data.csvColumns; track col) {
                <td>{{ row[col] ?? '—' }}</td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  @if (data.existingColumns.length > 0) {
    <details class="existing-columns-details mt-2">
      <summary>Existing columns ({{ data.existingColumns.length }})</summary>
      <div class="existing-columns-list">
        @for (col of data.existingColumns; track col) {
          <code class="existing-col">{{ col }}</code>
        }
      </div>
    </details>
  }

  @if (data.errors && data.errors.length > 0) {
    <div class="alert alert-danger mt-3">
      <strong>Warnings:</strong>
      <ul class="mb-0 mt-1">
        @for (err of data.errors; track err) {
          <li>{{ err }}</li>
        }
      </ul>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end" class="preview-actions">
  <button type="button" class="btn btn-secondary" (click)="onCancel()">Cancel</button>
  <button
    type="button"
    class="btn btn-primary"
    [disabled]="data.errors.length > 0 || (data.newDataRows === 0 && data.newColumns.length === 0)"
    (click)="onConfirm()"
  >
    <i class="fas fa-check me-1"></i>Confirm and import
  </button>
</mat-dialog-actions>
